import React from 'react';
import Modal from '../components/Modal';
import ProfileView from './ProfileView';
import { useLanguage } from '../i18n/LanguageContext';

// The full profile in a modal - opened from the profile card.
export default function FullProfileModal({ username, onClose }) {
  const { t } = useLanguage();
  return (
    <Modal mState={{ iShow: true, setiShow: (v) => { if (!v) onClose(); } }} buttonShow className="ProfileFullModalContainer">
      <ProfileView
        username={username}
        onNavigate={onClose}
        footer={(
          <div className="ConfirmModalActions">
            <button type="button" className="SendButton secondaryColor" onClick={onClose}>{t('common.close')}</button>
          </div>
        )}
      />
    </Modal>
  );
}
